import { Component, OnInit, inject } from "@angular/core";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { filter } from "rxjs/operators";
import { LoadingComponent } from "src/app/shared/components/loader/loading/loading.component";
import { environment } from "src/environments/environment";
import { BaseComponent } from "../../base/base.component";
import { MenuService } from "../../services/menu-service.service";

@Component({
  selector: "app-layout-login",
  imports: [RouterOutlet, LoadingComponent],
  templateUrl: "./layout-login.component.html",
})
export class LayoutLoginComponent extends BaseComponent implements OnInit {
  // Injections
  private menuService = inject(MenuService);
  private router = inject(Router);

  // variable
  appVersion: string = environment.version;
  isDarkMode: boolean = false;
  showLogoAndVersion = true;

  ngOnInit(): void {
    this.updateShowLogoAndVersion(this.router.url);
    this.onSubscribe();
  }

  //#region Events and synchronization
  onSubscribe() {
    this.subs.push(
      this.menuService.onThemeApplyed$.subscribe((isDarkMode: boolean) => {
        this.isDarkMode = isDarkMode;
      }),
    );

    this.subs.push(
      this.router.events
        .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event) => this.updateShowLogoAndVersion(event.urlAfterRedirects)),
    );
  }

  private updateShowLogoAndVersion(url: string): void {
    this.showLogoAndVersion = !url.includes("/comandaemesa");
  }
}
